import { CallCreationRequestForm } from '@act/shared/data-transfer-objects';
import { FormConfig } from 'stories/forms/FormBuilder/formBuilder.types';
import { Goal } from 'stories/containers/GoalsTracking/types';

interface PhoneNumberOption {
  label: string;
  value: number;
  number: string;
}

export const createCallFormConfig = (
  isResourceCall: boolean,
  goals: Goal[],
  phoneNumberOptions: PhoneNumberOption[]
): FormConfig<CallCreationRequestForm> => {
  if (isResourceCall) {
    return [
      {
        type: 'input',
        name: 'resourceInteraction.title',
        label: 'Resource Title',
        input: 'text',
      },
      {
        type: 'input',
        name: 'resourceInteraction.phoneNumber',
        label: 'Resource Phone Number',
        input: 'phone',
      },
      {
        type: 'input',
        name: 'userNeedId',
        label: 'Need for this resource',
        input: 'select',
        props: {
          options: goals
            .filter(goal => goal.goalType === 'need')
            .map(goal => ({
              label: 'issueLabel' in goal ? goal.issueLabel : 'Need',
              value: goal.id,
            })),
        },
      },
    ];
  }

  return [
    {
      type: 'input',
      name: 'phoneNumberId',
      label: 'Phone Number',
      input: 'select',
      props: {
        options: phoneNumberOptions,
      },
    },
  ];
};
